import session from '@updater-core/interactors/shell/session';
import siteBranding from '@updater-core/interactors/shell/site-branding';
import { createInteractor } from './interactor';

export function buildJourney() {
  return createInteractor({
    session,
    siteBranding,
  });
}

export default buildJourney();
